import React from 'react'
import asyncComponent from '../../../util/asyncComponent'
import {Route,Switch} from 'react-router-dom'
const Consult=({match})=>(
    <Switch>
      <Route path={`${match.url}/SpecificVoucher`} component={asyncComponent(()=>import('./SpecificVoucher/index'))}/>
      <Route path={`${match.url}/Account`} component={asyncComponent(()=>import('./Account/index'))}/>
    </Switch>
)
export default Consult;